import { appLoaderType } from './types';

/**
 * @param message NMU-524: optional text shown under the spinner, e.g.
 *   "กำลังอัปโหลดไฟล์... 45%". Omitted by every existing caller, which is why it
 *   is a parameter rather than a separate action — a plain `enable()` keeps its
 *   old meaning and shows no text.
 */
const enable = (message) => {
    return {
        type: appLoaderType.ENABLE,
        message
    }
}

const disale = () => {
    return {
        type: appLoaderType.DISABLE
    }
}

const appLoaderAction = {
    enable,
    disale
}

export default appLoaderAction;